import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import { required } from 'vuelidate/lib/validators';
import RefundThresholdUpdate from '@/plugins/graphql/mutations/v2/refund-threshold-update.gql';
import ActionButton from '@/components/action_button/Index.vue';
import BaseSubtitle from '@/components/v2/BaseSubtitle';
import NumericInput from '@/components/v2/NumericInput.vue';
let RefundThresholdDialog = class RefundThresholdDialog extends mixins(AlertMixin, ButtonLoaderMixin, RouterParamsAppMixin, FormMixin) {
    constructor() {
        super(...arguments);
        this.form = {
            appUuid: '',
            dailyRefundThreshold: 0,
        };
        this.mutationRequestOnFlight = false;
    }
    hideDialog() {
        this.toggle = false;
    }
    onSubmit() {
        this.requestOnFlight();
        if (!this.$v.$invalid) {
            this.update(this.form)
                .then(() => {
                this.hideDialog();
                this.successNotification('Success');
            })
                .catch((err) => {
                this.errorNotification(err.message);
            })
                .finally(() => {
                this.requestDone();
            });
        }
        else {
            this.errorNotification('Amount is required');
        }
    }
    async update(form) {
        return this.$apollo.mutate({
            mutation: RefundThresholdUpdate,
            variables: {
                input: {
                    appUuid: this.appUuid,
                    dailyRefundThreshold: form.dailyRefundThreshold,
                },
            },
        });
    }
};
__decorate([
    Prop({ type: String, required: true })
], RefundThresholdDialog.prototype, "appUuid", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], RefundThresholdDialog.prototype, "toggle", void 0);
RefundThresholdDialog = __decorate([
    Component({
        components: {
            ActionButton,
            BaseSubtitle,
            NumericInput,
        },
        validations: {
            form: {
                dailyRefundThreshold: {
                    required,
                },
            },
        },
    })
], RefundThresholdDialog);
export default RefundThresholdDialog;
